import { GTC_CLIENT_TIMEZONE_HEADER } from "constants/gtc";

export const clientTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? "";
  } catch {
    return "";
  }
};

export const gtcAcceptHeaders = (): Record<string, string> => {
  const timezone = clientTimezone();
  if (!timezone) {
    return {};
  }
  return { [GTC_CLIENT_TIMEZONE_HEADER]: timezone };
};
